import { render } from "./OttoTeamMember.vue?vue&type=template&id=5ee5f696&scoped=true&ts=true"
import script from "./OttoTeamMember.vue?vue&type=script&lang=ts"
export * from "./OttoTeamMember.vue?vue&type=script&lang=ts"

import "./OttoTeamMember.vue?vue&type=style&index=0&id=5ee5f696&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee5f696"]])

export default __exports__